// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsOverview = {
  title: "Asset Center",
  subtitle: "The current governance view of the unified platform asset domain.",
  menu: {
    governance: "Governance",
    objectSpaces: "Object Spaces",
    references: "References",
    mySpace: "My Space",
  },
  login: {
    pageTitle: "{platformName} · Asset Center",
    maintenanceNotice: "Asset center is under maintenance. Some capabilities may be unavailable.",
    noAccess: "The current unified identity does not have access to the asset center.",
  },
  directRead:
    "This page now reads asset-center asset master data and object space governance data directly.",
  indirectRead:
    "The current session is not using unified identity. This page only shows link state until you sign in through unified identity.",
  summaryProvider: "Asset provider: {value}",
  summaryMode: "Read mode: {value}",
  summaryAssets: "Total assets: {count}",
  summaryInUse: "In use: {count}",
  governanceReadRestricted:
    "This account can read asset master data. Object-space and reference governance summaries are visible to asset admins only.",
  summarySpaces: "Object spaces: {count}",
  summaryManagedSpaces: "Managed spaces: {count}",
  summaryBlockedDeleteAssets: "Delete-blocked assets: {count}",
  summaryPendingUploads: "Pending uploads: {count}",
  summarySize: "Total size: {value}",
  legend: {
    provider: "Asset provider",
    mode: "Read mode",
    assets: "Total assets",
    inUse: "In use",
    spaces: "Object spaces",
    managedSpaces: "Managed spaces",
    blockedDeleteAssets: "Delete-blocked assets",
    pendingUploads: "Pending uploads",
    remediation: "Remediation items",
    remediationCritical: "Critical remediation",
    size: "Total size",
    mySpaceUsed: "Used",
    mySpaceQuota: "Quota",
    mySpaceRemaining: "Remaining",
    mySpaceFiles: "Files",
    publicBrandingUsed: "Branding space used",
    publicBrandingQuota: "Branding space quota",
    publicBrandingRemaining: "Branding space remaining",
    publicBrandingFiles: "Branding files",
    mySharedFiles: "Shared to Public",
    publicSharedFiles: "Public Shared Files",
    publicSharedActive: "Sharing",
  },
  directMode: "Center Direct",
  indirectMode: "Link State",
  providerLabel: "Current provider: {value}",
  centerBaseUrl: "Asset center URL: {value}",
  openCenter: "Open Asset Center",
  openExamAssets: "Open Exam Assets",
  cards: {
    access: "Access",
    controlPlane: "Control Plane",
    mySpace: "My Space",
    fullAccessEndpoints: "Full Access Endpoints",
    rawConfigJson: "Raw config_json",
    rawRuntimeJson: "Raw runtime_json",
  },
  controlPlaneFields: {
    managedSpaces: "Managed spaces",
    readonlySpaces: "Read-only spaces",
    disabledSpaces: "Disabled spaces",
    spacesWithoutGrants: "Spaces without grants",
    referenceBindings: "Reference bindings",
    blockedDeleteAssets: "Delete-blocked assets",
    pendingUploads: "Pending uploads",
    uploadedRequests: "Uploaded requests",
    readyRequests: "Ready requests",
    failedRequests: "Failed requests",
    governedSpaces: "Governed spaces",
    warningSpaces: "Warning spaces",
    blockedSpaces: "Blocked spaces",
    unmanagedSpaces: "Unmanaged spaces",
    applicationGrants: "Application grants",
    userGrants: "User grants",
    referenceServices: "Reference services",
    referenceScopes: "Reference scopes",
    referenceWarningRows: "Reference warnings",
    crossScopeRows: "Cross-scope references",
    highBindingRows: "High-binding references",
    remediationItems: "Remediation items",
    remediationCritical: "Critical remediation",
    remediationObjectSpaces: "Space remediation",
    remediationReferences: "Reference remediation",
    remediation: "Remediation",
  },
  tables: {
    spaces: "Object Spaces",
    spacesSubtitle:
      "Object spaces are grouped by asset object-key prefix for governance, ownership, and capacity review.",
    latestAssets: "Latest Assets",
    latestAssetsSubtitle:
      "Directly reads the latest asset samples from asset-center for platform inspection and governance walkthrough.",
    refs: "Cross-business Reference Catalog",
    refsSubtitle:
      "Shows the normalized cross-business reference dimensions currently accepted by asset-center.",
  },
  tabs: {
    governance: "Governance",
    references: "References",
    mySpace: "My Space",
  },
} as const;
